if (typeof ShippingNotice !== 'function') {
    class ShippingNotice extends HTMLElement {
        constructor() {
            super();
            this.init();
            this.setupProgressBar();
        }

        setupProgressBar() {
            this.progressContainer = this.querySelector('.progress-container');
            this.remainingAmountSpan = this.progressContainer?.querySelector('.remaining-amount');
            this.updateProgressBar(null, this.remainingAmountSpan);
        }

        updateProgressBar(icon, progressThumb) {
            const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
            const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
            const progressWidth = cartTotal < freeShippingThreshold ? (cartTotal / freeShippingThreshold) * 100 : 100;
            progressThumb ? progressThumb.style.width = `${progressWidth}%` : '';
            icon ? progressWidth == 100 ? icon.style.display = 'block' : icon.style.display = 'none' : '';
        }

        init() {
            const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
            const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
            const freeShippingRemaining = cartTotal - freeShippingThreshold;
            const shippingMessageEl = this.querySelector('.free-shipping-text');
            let shippingMessage = '';
            let shippingSuccess = false
            if (freeShippingRemaining < 0) {
                shippingMessage = window.cartStrings.shippingRemainingToFree.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), window.cartStrings.moneyFormat));
            } else {
                shippingMessage = window.cartStrings.shippingEligibleForFree;
                shippingSuccess = true;
            }
            shippingMessageEl.innerHTML = shippingMessage;
        }

        _formatMoney(cents, format) {
            if (typeof cents === 'string') {
                cents = cents.replace('.', '');
            }
            let value = '';
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            const formatString = format || moneyFormat;
            function formatWithDelimiters(number, precision, thousands, decimal) {
                thousands = thousands || ',';
                decimal = decimal || '.';
                if (isNaN(number) || number === null) {
                    return 0;
                }
                number = (number / 100.0).toFixed(precision);
                const parts = number.split('.');
                const dollarsAmount = parts[0].replace(
                    /(\d)(?=(\d\d\d)+(?!\d))/g,
                    '$1' + thousands
                );
                const centsAmount = parts[1] && parts[1] !== '00' ? decimal + parts[1] : '';
                return dollarsAmount + centsAmount;
            }
            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
                case 'amount_no_decimals_with_space_separator':
                    value = formatWithDelimiters(cents, 0, ' ');
                    break;
                case 'amount_with_apostrophe_separator':
                    value = formatWithDelimiters(cents, 2, "'");
                    break;
            }
            return formatString.replace(placeholderRegex, value);
        }
    }
    if (typeof customElements.get('shipping-notice') == 'undefined') {
        customElements.define('shipping-notice', ShippingNotice);
    }
}
